import React from "react";
import { toast } from "react-toastify";

const TicketPill = ({
  ticketNumber,
  copyValue,
  isCompact,
}: {
  ticketNumber: string;
  copyValue?: string;
  isCompact: boolean;
}) => (
  <span
    style={{
      backgroundColor: "#032e5b",
      color: "#ffffff",
      padding: "4px 12px",
      borderRadius: "14px",
      fontSize: isCompact ? "12px" : "14px",
      fontWeight: 600,
      whiteSpace: "nowrap",
      letterSpacing: "0.3px",
      cursor: "pointer",
    }}
    onClick={(e) => {
      e.stopPropagation();
      navigator.clipboard.writeText(copyValue ?? ticketNumber);
      toast.success(`Copied ${copyValue ?? ticketNumber}`, { autoClose: 1500 });
    }}
  >
    {ticketNumber}
  </span>
);

export default TicketPill;
